import { useAppSelector } from '../../hooks';
import { IntegrationItem, TabsTypes } from 'pages/connectors/types';

export const useActiveIntegrationSelector = (): IntegrationItem =>
  useAppSelector(({ connectors }) => connectors.activeIntegration);

export const useIntegrationsListStateSelector = (): TabsTypes =>
  useAppSelector(({ connectors }) => connectors.integrationsListState);
